import styled from 'styled-components';
import Chevron from '../../../public/chevron.svg';
import { rgba } from 'polished';
import { OptionContainer } from './components/Option/Option.styles';

export const Container = styled.div<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ disabled, theme }) =>
    disabled &&
    `pointer-events: none;
    ${ContentAndArrowContainer} {
      box-shadow: none;
      background-color: ${rgba(theme.colors.functional.white, 0.75)};
    }
  `}
`;

export const SelectedOptionContainer = styled.div`
  pointer-events: inherit;
`;

export const ListContainer = styled.div`
  position: relative;
`;

export const Content = styled.div<{ forSelectedOption?: boolean }>`
  width: 100%;
  height: 100%;
  height: 76px;
  display: flex;
  align-items: center;
  pointer-events: inherit;
  :last-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.main};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.main};
    overflow: hidden;
  }
  ${({ forSelectedOption }) => forSelectedOption && ``}
`;

export const List = styled.ul`
  border-radius: ${({ theme }) => theme.borderRadius.main};
  position: absolute;
  top: 0;
  padding-top: 76px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.functional.white};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.main};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.main};
  box-shadow: ${({ theme }) => theme.boxShadow.black};
  ${Content} {
    border-top: 2px solid ${({ theme }) => theme.colors.functional.gray3};
  }
`;

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
`;

export const ChevronIcon = styled(Chevron)<{ $rotate?: boolean; disabled?: boolean }>`
  width: 24px;
  img,
  svg {
    width: 24px;
  }

  ${({ $rotate }) => $rotate && `transform: rotate(180deg);`};

  ${({
    disabled,
    theme: {
      colors: {
        functional: { gray5 },
      },
    },
  }) => disabled && ` path { fill: ${gray5} !important; }`}
`;

export const ContentAndArrowContainer = styled.div<{ isOpen?: boolean }>`
  width: 100%;
  height: 76px;
  display: flex;
  position: relative;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.functional.white};
  box-shadow: ${({ theme }) => theme.boxShadow.black};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  overflow: hidden;
  cursor: pointer;
  ${({ isOpen }) =>
    isOpen &&
    `
      z-index: 4;
      box-shadow: none;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
  `};
  ${OptionContainer} {
    box-shadow: none;
  }
`;
